import React, { useState } from "react";

const NAMA_BULAN = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mei",
  "Jun",
  "Jul",
  "Agu",
  "Sep",
  "Okt",
  "Nov",
  "Des",
];

const SERIES = [
  { key: "MESIN", label: "Mesin", color: "#0e5d5a" },
  { key: "MOLD", label: "Mold", color: "#4ca756" },
  { key: "BAHAN", label: "Bahan", color: "#e0a526" },
];

const W = 720;
const H = 320;
const M = { t: 24, r: 16, b: 36, l: 40 };
const IW = W - M.l - M.r;
const IH = H - M.t - M.b;

const LkmAnalytics = ({ data }) => {
  const [hover, setHover] = useState(null);

  if (!data || !data.months) {
    return <p className="lkm-empty">Memuat grafik...</p>;
  }

  const { months, year } = data;
  const sum = (key) => months.reduce((a, m) => a + (m[key] || 0), 0);
  const totalYear = sum("total");
  const doneYear = sum("done");

  const maxTotal = Math.max(0, ...months.map((m) => m.total));
  const max = Math.max(4, Math.ceil(maxTotal / 4) * 4);
  const ticks = [0, 1, 2, 3, 4].map((i) => (max / 4) * i);
  const slot = IW / 12;
  const barW = slot * 0.6;

  return (
    <div className="lkm-analytics">
      <div className="lkm-analytics-cards">
        <div className="lkm-analytics-card">
          <p>Total LKM {year}</p>
          <b>{totalYear}</b>
        </div>
        <div className="lkm-analytics-card">
          <p>Selesai</p>
          <b>{doneYear}</b>
        </div>
        {SERIES.map((s) => (
          <div className="lkm-analytics-card" key={s.key}>
            <p>
              <span className="lkm-dot" style={{ background: s.color }} />
              {s.label}
            </p>
            <b>{sum(s.key)}</b>
          </div>
        ))}
      </div>

      <div className="lkm-chart-wrap">
        <p className="lkm-chart-title">Jumlah LKM per bulan, {year}</p>
        <div className="lkm-chart-canvas">
          <svg
            viewBox={`0 0 ${W} ${H}`}
            width="100%"
            role="img"
            aria-label={`Grafik jumlah LKM per bulan tahun ${year}`}
          >
            {ticks.map((t) => {
              const y = M.t + IH - (t / max) * IH;
              return (
                <g key={t}>
                  <line x1={M.l} x2={W - M.r} y1={y} y2={y} stroke="#e3e3e3" />
                  <text
                    x={M.l - 8}
                    y={y + 4}
                    textAnchor="end"
                    fontSize="11"
                    fill="#666"
                  >
                    {t}
                  </text>
                </g>
              );
            })}

            {months.map((m, i) => {
              const x = M.l + i * slot + (slot - barW) / 2;
              let yCursor = M.t + IH;
              return (
                <g key={m.bulan}>
                  {hover === i && (
                    <rect
                      x={M.l + i * slot}
                      y={M.t}
                      width={slot}
                      height={IH}
                      fill="#0e5d5a"
                      opacity="0.08"
                    />
                  )}
                  {SERIES.map((s) => {
                    const h = (m[s.key] / max) * IH;
                    yCursor -= h;
                    return h > 0 ? (
                      <rect
                        key={s.key}
                        x={x}
                        y={yCursor}
                        width={barW}
                        height={h}
                        fill={s.color}
                      />
                    ) : null;
                  })}
                  {m.total > 0 && (
                    <text
                      x={x + barW / 2}
                      y={yCursor - 5}
                      textAnchor="middle"
                      fontSize="11"
                      fontWeight="600"
                      fill="#333"
                    >
                      {m.total}
                    </text>
                  )}
                  <text
                    x={x + barW / 2}
                    y={H - 14}
                    textAnchor="middle"
                    fontSize="11"
                    fill="#666"
                  >
                    {NAMA_BULAN[i]}
                  </text>
                  <rect
                    x={M.l + i * slot}
                    y={M.t}
                    width={slot}
                    height={IH + 24}
                    fill="transparent"
                    style={{ cursor: "pointer" }}
                    onMouseEnter={() => setHover(i)}
                    onMouseLeave={() => setHover(null)}
                    onClick={() => setHover(i)}
                  />
                </g>
              );
            })}
          </svg>
          {hover !== null && months[hover] && (
            <div
              className="lkm-tooltip"
              style={{
                left: `${Math.min(
                  86,
                  Math.max(14, ((M.l + hover * slot + slot / 2) / W) * 100)
                )}%`,
              }}
            >
              <b>
                {NAMA_BULAN[hover]} {year}
              </b>
              {SERIES.map((s) => (
                <div key={s.key}>
                  <span className="lkm-dot" style={{ background: s.color }} />
                  {s.label}: {months[hover][s.key]}
                </div>
              ))}
              <div className="lkm-tooltip-total">
                Total: {months[hover].total} · Selesai: {months[hover].done}
              </div>
            </div>
          )}
        </div>

        <div className="lkm-legend">
          {SERIES.map((s) => (
            <span key={s.key}>
              <span className="lkm-dot" style={{ background: s.color }} />
              {s.label}
            </span>
          ))}
        </div>
      </div>

      <div className="lkm-analytics-table">
        <table className="font10-mobile-lkm">
          <thead>
            <tr>
              <th>Bulan</th>
              <th>Mesin</th>
              <th>Mold</th>
              <th>Bahan</th>
              <th>Total</th>
              <th>Selesai</th>
            </tr>
          </thead>
          <tbody>
            {months.map((m, i) => (
              <tr key={m.bulan}>
                <td>{NAMA_BULAN[i]}</td>
                <td>{m.MESIN}</td>
                <td>{m.MOLD}</td>
                <td>{m.BAHAN}</td>
                <td>
                  <b>{m.total}</b>
                </td>
                <td>{m.done}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LkmAnalytics;
